// init fonts
export default class FontFactory {
  static getFontURLs() {
    return [
/*
      'symbol-and-rune/Alpmagi',
      'symbol-and-rune/BLF',
      'symbol-and-rune/BLN',
      'symbol-and-rune/EnochianPlain',
      'symbol-and-rune/Erebcap',
      'symbol-and-rune/Erebor',
      'symbol-and-rune/FUTHA',
      'symbol-and-rune/Highschool_Runes',
      'symbol-and-rune/Rune',
      'symbol-and-rune/Sigali-Script',
      'symbol-and-rune/TengwarAnnatar',
      'symbol-and-rune/norskode',
      'symbol-and-rune/pulsian',

      'deities/Deities',
      'deities/Hieroglify',
      'deities/OffAncientEgyptian',
      'deities/TheNileSong',
      'deities/101AztecSymbolz',

      'digital/Kroeger',
*/
/*
      'ransom/2PeasGift',
      'ransom/Broken15',
      'ransom/GotHeroin',
      'ransom/MetacopyPlain',

      'handwritten/AckiPreschool',
      'handwritten/ChildrenOnceWhere',
      'handwritten/LaterOn',
      'handwritten/Nostringsattatched',
      'handwritten/ScratchedCarPaint',
      'handwritten/TrojaScriptBold',

      'typewriter/ImpactLabel',
      'typewriter/ImpactLabelReversed',
*/
/*
      'dingbats/Acaslonornamentsmodified',
      'dingbats/BergamotOrnaments',
      'dingbats/Byzantium',
      'dingbats/Ccdiv',
      'dingbats/CelticDesignsI',
      'dingbats/Decoborders',
      'dingbats/Decodividers',
      'dingbats/Nymphette',
      'dingbats/Rosette',
      'dingbats/Wwdesigns',
*/
      'frames/CelticFrames',
      'frames/DarriansFrames',
      'frames/DarriansFramesTwo',
      'frames/Opattfram01.otf',
      'frames/LotsOfFrames'
    ]
  }

  static getFonts() {
    let fonts = FontFactory.getFontURLs()

    return fonts.map(f => f.split('/').pop().split('.')[0])
  }

  constructor() {
    this.fonts = FontFactory.getFontURLs()

    for (let i = 0; i < this.fonts.length; i++) {
      let fontURL = this.fonts[i],
          font = this.fonts[i].split('/').pop().split('.')[0]

      // almost all of them are ttf files
      if (!fontURL.match(/\.(otf|ttf)/g)) {
        fontURL += '.ttf'
      }

      let fontFace = new FontFace(font, `url(/fonts/${fontURL})`);
      document.fonts.add(fontFace)

      let id = `tmp-${i}`

      let style = document.createElement('style')
      style.innerHTML =
        `#${id} {
          font-family: '${font}' !important;
          background: white;
          color: white;
        }`;
      style.classList.add('preload-font')
      document.body.appendChild(style)

      let tmp = document.createElement('div')
      tmp.id = id
      tmp.innerText = 'abcd'
      tmp.classList.add('preload-font')

      document.body.appendChild(tmp)
    }
  }

  removeElementsByClass(className){
    var elements = document.getElementsByClassName(className);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
  }

  cleanup() {
    this.removeElementsByClass('preload-font')
  }
}
